export default __webpack_public_path__ + "static/media/template13.ebb80b4b.jpg";